import { endSession } from '../../lib/session-end'
import { lastActivity } from './activity'
import { sessionPhase } from './session-clock'

/*
 * Why the back office's session ended, for the sign-in page to say so (`/entrar?motivo=…`): the
 * person signed out, 30 minutes passed without activity, the 8 hours passed, or the server closed
 * it (a new sign-in elsewhere, or the operator tool). The end reaches every tab of this browser
 * through lib/session-end.ts, the portal's mechanism; not its channel, since each host is an
 * origin of its own.
 */

export const END_REASONS = ['salida', 'inactividad', 'caducada', 'cerrada'] as const
export type EndReason = (typeof END_REASONS)[number]

let pending: EndReason | null = null
let times: { endsAt: number; idleMinutes: number } | null = null

/** The signed-in session's limits, kept from when the panel shows it until it ends. */
export function rememberSessionLimits(limits: { endsAt: number; idleMinutes: number }): void {
  times = limits
}

/** Whether this tab has shown a signed-in session that has not ended yet. */
export function hadSession(): boolean {
  return times !== null
}

/** The session ended in this tab: every tab lets go, and this one says why. */
export function endStaffSession(reason?: EndReason): void {
  pending = reason ?? inferredReason()
  endSession()
}

/**
 * Why the session ended, once: what this tab knows, or else what its limits say (another tab's
 * end, or a refusal of the server, arrive without a reason).
 */
export function takeEndReason(): EndReason {
  const reason = pending ?? inferredReason()
  pending = null
  times = null
  return reason
}

function inferredReason(now = Date.now()): EndReason {
  if (!times) return 'cerrada'
  const { over } = sessionPhase({ now, lastActivity: lastActivity(), ...times })
  return over === 'expired' ? 'caducada' : over === 'idle' ? 'inactividad' : 'cerrada'
}
